import {
  BulkSignOrchestratorApiTypes,
  bulkSignOrchestratorApi,
} from "@rshbintech.dboul/http";

import { BatchedDocumentsItemMap, Document } from "../types";
import { updateDocumentsWithCcb } from "./update-documents-with-ccb";

// получение ККБ, не обязательно по всей пачке, хотя бы по одному документу
export const getBatchCcb = async (
  documentsInBatch: number,
  taskId: string,
  unsignedDocuments: Document[]
): Promise<BatchedDocumentsItemMap | undefined> => {
  const ccbResponse = await bulkSignOrchestratorApi.api.getCcb(taskId, {
    offset: 0,
    limit: documentsInBatch,
  });

  const ccb = ccbResponse?.data?.ccb;

  const isCcbList = (
    ccbList?: BulkSignOrchestratorApiTypes.CcbData[]
  ): ccbList is BulkSignOrchestratorApiTypes.CcbData[] =>
    Array.isArray(ccbList);

  if (ccb && isCcbList(ccb) && ccb.length) {
    return updateDocumentsWithCcb(unsignedDocuments, ccb);
  }
};
